module.exports = __webpack_public_path__ + "img/fan_bu_dai.f323f721.png";